import { createContext, useContext } from "react";

import type { PresetKey } from "../lib/theme/presets";

export type ThemePreference = "light" | "dark" | "system";

export type ThemeContextValue = {
  preference: ThemePreference;
  resolvedTheme: "light" | "dark";
  setPreference: (preference: ThemePreference) => void;
  /** The business's preset (P5-014), drawn in whichever appearance is chosen. */
  setBrand: (brand: PresetKey) => void;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider.");
  }
  return context;
}
